
import Component from 'vue-class-component';
import Vue from 'vue';
import Topbar from '@/core/components/Topbar.vue';
import PageError from '@/core/components/PageError.vue';

@Component({
	components: {
		Topbar,
		PageError,
	},
})
export default class NotFound extends Vue {}

